import type { SVGProps } from "react";
const SvgArrowRight = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M924.293 85.2929C924.683 84.9024 925.317 84.9024 925.707 85.2929L931.707 91.2929C932.098 91.6834 932.098 92.3166 931.707 92.7071L925.707 98.7071C925.317 99.0976 924.683 99.0976 924.293 98.7071C923.902 98.3166 923.902 97.6834 924.293 97.2929L928.586 93H917C916.448 93 916 92.5523 916 92C916 91.4477 916.448 91 917 91H928.586L924.293 86.7071C923.902 86.3166 923.902 85.6834 924.293 85.2929Z"
      fill="currentColor"
      transform="translate(-912 -80)"
    />
  </svg>
);
export default SvgArrowRight;
